export default __webpack_public_path__ + "static/assets/SL-magnets-white-opaque.f733c90b.png";